import { useEffect } from "react";
import { Popover } from "antd";
import { CommonButton } from "@components/CommonButton";
import MemberPopoverContent from "@components/MemberPopoverContent";
import { useAppDispatch, useAppSelector } from "@hooks/redux";
import { fetchAiCredits } from "@store/globalSlice";

type CommonButtonProps = React.ComponentProps<typeof CommonButton>;

export interface CreditGuardButtonProps extends CommonButtonProps {
  /** 触发"积分不足"守卫的最低积分阈值，低于此值禁用按钮并展示提示。 */
  requiredCredits?: number;
}

const DEFAULT_REQUIRED_CREDITS = 10;

export const CreditGuardButton = ({
  requiredCredits = DEFAULT_REQUIRED_CREDITS,
  disabled,
  locked,
  onClick,
  ...rest
}: CreditGuardButtonProps) => {
  const dispatch = useAppDispatch();
  const totalRemain = useAppSelector((state) => state.globalReducer.creditInfo.totalRemain);
  const creditLoading = useAppSelector((state) => state.globalReducer.creditLoading);

  useEffect(() => {
    dispatch(fetchAiCredits());
  }, [dispatch]);

  // 余额未到达前不做"积分不足"判断，避免把请求中误当作不足。
  const isInsufficient = !creditLoading && totalRemain < requiredCredits;

  const button = (
    <CommonButton
      {...rest}
      disabled={disabled || creditLoading || isInsufficient}
      locked={locked || isInsufficient}
      onClick={creditLoading || isInsufficient ? undefined : onClick}
    />
  );

  if (!isInsufficient) return button;

  return (
    <Popover content={<MemberPopoverContent remainCredit={totalRemain} action="Credits" />} trigger="hover">
      {button}
    </Popover>
  );
};
